import type { BreadcrumbItem as BreadcrumbItemUI } from '@svoi-ui/interfaces/breadcrumbs'

function toApiPath(path: string): string {
  if (!path || path === '/') return 'main'
  return `main/${path.replace(/^\/+|\/+$/g, '')}`
}

function toUIItems(items: Array<{ title: string, url: string }>): BreadcrumbItemUI[] {
  return items.map((item, index) => ({
    title: item.title,
    link: index === items.length - 1 ? undefined : (item.url || undefined),
  }))
}

const DEFAULT_BREADCRUMBS: BreadcrumbItemUI[] = [{ title: 'Главная', link: '/' }]

interface UseBreadcrumbsOptions {
  rubricId?: Ref<number | string | undefined> | number | string
}

export async function useBreadcrumbs(options: UseBreadcrumbsOptions = {}) {
  const route = useRoute()
  const { $services } = useNuxtApp()

  const rubricId = computed(() => {
    const val = unref(options.rubricId)
    return val !== undefined && val !== null ? val : undefined
  })

  const { data: breadcrumbs } = await useAsyncData(
    `breadcrumbs-${route.path}-${rubricId.value ?? ''}`,
    async () => {
      try {
        const items = await $services.breadcrumbsService.getList(
          toApiPath(route.path),
          rubricId.value,
        )
        return items.length > 0 ? toUIItems(items) : DEFAULT_BREADCRUMBS
      }
      catch (error) {
        console.warn('[useBreadcrumbs] Failed to fetch breadcrumbs:', error)
        return DEFAULT_BREADCRUMBS
      }
    },
  )

  const items = computed(() => breadcrumbs.value ?? DEFAULT_BREADCRUMBS)

  return { breadcrumbs: items }
}
